export const WINDS = ["Восток", "Юг", "Запад", "Север"];
export const WIND_KANJI = ["東", "南", "西", "北"];

export const YAKU: Record<string, string> = {
  riichi: "Риичи",
  double_riichi: "Дабл риичи",
  ippatsu: "Иппацу",
  menzen_tsumo: "Мэндзэн цумо",
  pinfu: "Пинфу",
  tanyao: "Таняо",
  iipeikou: "Иипэйко",
  haku: "Якухай: Хаку",
  hatsu: "Якухай: Хацу",
  chun: "Якухай: Чун",
  seat_wind: "Якухай: ветер места",
  round_wind: "Якухай: ветер раунда",
  haitei: "Хайтэй раоюэ",
  houtei: "Хоутэй раоюй",
  rinshan: "Риншан кайхо",
  chankan: "Чанкан",
  chiitoitsu: "Читойцу",
  chanta: "Чанта",
  ittsu: "Иццу",
  sanshoku: "Саншоку доудзюн",
  sanshoku_doukou: "Саншоку доко",
  toitoi: "Тойтой",
  sanankou: "Санъанко",
  sankantsu: "Санканцу",
  shousangen: "Сёсангэн",
  honroutou: "Хонрото",
  ryanpeikou: "Рянпэйко",
  junchan: "Джунчан",
  honitsu: "Хонъицу",
  chinitsu: "Чиницу",
  kokushi: "Кокуши мусо",
  kokushi13: "Кокуши мусо (13 ожиданий)",
  suuankou: "Сууанко",
  suuankou_tanki: "Сууанко танки",
  daisangen: "Дайсангэн",
  shousuushii: "Сёсууши",
  daisuushii: "Дайсууши",
  tsuuiisou: "Цуиисо",
  ryuuiisou: "Рюиисо",
  chinroutou: "Чинрото",
  chuuren: "Чуурэн поото",
  junsei_chuuren: "Дзюнсэй чуурэн поото",
  suukantsu: "Сууканцу",
  tenhou: "Тэнхо",
  chiihou: "Тихо",
};

export const LIMITS: Record<string, string> = {
  mangan: "Манган",
  haneman: "Ханеман",
  baiman: "Байман",
  sanbaiman: "Санбайман",
  kazoe: "Кадзоэ якуман",
  yakuman: "Якуман",
};

export const ABORTS: Record<string, string> = {
  kyuushu: "Кюсю кюхай (9 разных терминалов)",
  suufon_renda: "Суфон рэнда (4 одинаковых ветра)",
  suucha_riichi: "Сутя риичи (4 риичи)",
  suukaikan: "Суукайкан (4 кана)",
  sanchahou: "Санчахо (тройной рон)",
};

export const CALLS: Record<string, string> = {
  riichi: "Риичи!",
  pon: "Пон!",
  chi: "Чи!",
  kan: "Кан!",
  ron: "Рон!",
  tsumo: "Цумо!",
  draw: "Ничья",
  abort: "Ничья",
};
